export default __webpack_public_path__ + "static/media/Admin.6d4baae7.svg";